// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';
import { EventContactModel } from '../../types/EventContact';

setGenerator(uuidv4);

export default class EventContact extends Model {
    static table = 'event_contacts';

    static associations = {
        events: { type: 'belongs_to', key: 'event_id' },
        contacts: { type: 'belongs_to', key: 'contact_id' },
    };

    @field('event_id') eventId;
    @field('contact_id') contactId;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @field('sent_sms') sentSms;
    @field('sent_sms_at') sentSmsAt;
    @field('sent_email') sentEmail;
    @field('status') status;
    @field('sent_email_at') sentEmailAt;
    @field('sent_sms_status') sentSmsStatus;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
    @field('sent_sms') sentSms;
    @field('sent_sms_at') sentSmsAt;
    @field('sent_email') sentEmail;
    @field('sent_email_at') sentEmailAt;
}

export interface EventContactSimple {
    id: string;
    sentSms: boolean;
    sentSmsAt: string;
    sentSmsStatus: string;
    sentEmail: boolean;
    status: string;
    sentEmailAt: string;
    createdAt: string;
    updatedAt: string;
    contactId: string;
}

export const simplifyEventContact = (
    eventContact: EventContactModel,
): EventContactSimple => {
    return {
        id: eventContact.id,
        sentSms: eventContact.sentSms,
        sentSmsAt: eventContact.sentSmsAt,
        sentSmsStatus: eventContact.sentSmsStatus,
        sentEmail: eventContact.sentEmail,
        status: eventContact.status,
        sentEmailAt: eventContact.sentEmailAt,
        createdAt: eventContact.createdAt.toISOString(),
        updatedAt: eventContact.updatedAt.toISOString(),
        contactId: eventContact.contactId,
    };
};
